module.exports = __webpack_public_path__ + "img/invoice-white.8cf98bed.svg";